export default __webpack_public_path__ + "static/media/green1.26bbf07c.png";